import { token } from '@cp/shared/di';
import { Answer } from 'yandex-metrica-ab-react/dist/types';

export const AB_SSR_VALUE = token<Answer | undefined>('AB_SSR_VALUE');
